import axios from './_nestAxios'

export const obtenerAsTreeView = () => axios.get('/esquema-balance-general', { params: { tipoConsulta: 'tree-view' } })
export const obtenerAsSelect = () => axios.get('/esquema-balance-general', { params: { tipoConsulta: 'select' } })
export const obtenerAsSelect2 = params =>
  axios.get('/esquema-balance-general', { params: { tipoConsulta: 'select2', ...params } })
export const obtenerxIdAsEdicion = id => axios.get(`/esquema-balance-general/${id}`)

export const nuevo = data => axios.post('/esquema-balance-general', data)

export const actualizarxId = (id, data) => axios.put(`/esquema-balance-general/${id}`, data)

export const eliminarxId = id => axios.delete(`/esquema-balance-general/${id}`)
